import { LtvModalComponent } from '@io/application/ltv-calculation/ltv-modal/ltv-modal.component';

import { Component, EventEmitter, inject, Output } from '@angular/core';

import { ApContentPipe, ApContentService } from '@ap/content';
import { ApModalService, ModalClosedReason, ModalOptions } from '@ap/modal';
import { LoanToValue } from '@ap/ap-interface-apix-rs-hypotheken-renteoverzicht';
import { ApNotificationComponent } from '@ap/notification';
import { ApIconButtonLinkComponent } from '@ap/icon-link';

@Component({
    selector: 'ltv-calculation',
    standalone: true,
    imports: [ApContentPipe, ApNotificationComponent, ApIconButtonLinkComponent],
    templateUrl: './ltv-calculation.component.html'
})
export class LtvCalculationComponent {
    @Output() setLoanToValue = new EventEmitter<LoanToValue>();

    private readonly modalService = inject(ApModalService);
    private readonly contentService = inject(ApContentService);

    showNotification = false;

    openModal(): void {
        const modalOptions = new ModalOptions();
        modalOptions.title = this.contentService.get('title.loan-to-value.modal');
        const modalContainer = this.modalService.open(LtvModalComponent, modalOptions);

        modalContainer.afterClosed().subscribe((result) => {
            switch (result.reason) {
                case ModalClosedReason.ACCEPTED:
                    this.setLoanToValue.emit(result.data);
                    this.showNotification = false;
                    break;
                case ModalClosedReason.DECLINED:
                    this.showNotification = true;
                    this.setLoanToValue.emit(LoanToValue.NHG);
                    break;
            }
        });
    }

    resetNotification(): void {
        this.showNotification = false;
    }
}
